import Persistable from "../../storage/persistable";

export default class Drive extends Persistable {
    constructor(gameId, index) {
        super();

        this.gameId = gameId;
        this.index = index;
        this.startTime = null;
        this.endTime = null;
        this.startPeriod = null;
        this.endPeriod = null;
        this.completed = false;
        this.homeTeamHasPossession = null;
        this.startType = null;
        this.endType = null;
        this.scoringTeamId = null;
        this.totalTime = 0;
    }
}
